/**
 * @generated SignedSource<<ab5ff2f2d8ef93de3ccbdbed2bd62a8e>>
 * @relayHash 256238f0b5bbf8be9c1354156fcbf019
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a45bbfcccd8477665b704a072b03919caa8e4f98f1dad76a073ad87cd50ad9a0

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UpdatesTabAggQuery$variables = {
  containerId: string;
  shouldFetchUpdatesTabData: boolean;
  tagId: string;
};
export type UpdatesTabAggQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UpdatesTabAgg_data">;
};
export type UpdatesTabAggQuery = {
  response: UpdatesTabAggQuery$data;
  variables: UpdatesTabAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchUpdatesTabData"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagId"
},
v3 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v4 = {
  "kind": "Variable",
  "name": "tagId",
  "variableName": "tagId"
},
v5 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  (v4/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v9 = {
  "kind": "ScalarField",
  "name": "canCommentOnUpdates"
},
v10 = {
  "kind": "ScalarField",
  "name": "canEditUpdates"
},
v11 = {
  "kind": "ScalarField",
  "name": "key"
},
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v14 = {
  "kind": "ScalarField",
  "name": "summary"
},
v15 = {
  "kind": "ScalarField",
  "name": "description"
},
v16 = [
  (v7/*: any*/),
  (v14/*: any*/),
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v17 = {
  "kind": "ScalarField",
  "name": "url"
},
v18 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v19 = {
  "kind": "ScalarField",
  "name": "ari"
},
v20 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v21 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v22 = {
  "kind": "ScalarField",
  "name": "picture"
},
v23 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v24 = {
  "kind": "ScalarField",
  "name": "label"
},
v25 = {
  "kind": "ScalarField",
  "name": "start"
},
v26 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    {
      "kind": "ScalarField",
      "name": "end"
    }
  ]
},
v27 = [
  (v24/*: any*/),
  (v26/*: any*/)
],
v28 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "newDueDate",
  "plural": false,
  "selections": (v27/*: any*/)
},
v29 = [
  {
    "alias": "projectValue",
    "kind": "ScalarField",
    "name": "value"
  }
],
v30 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v23/*: any*/),
    (v12/*: any*/),
    (v7/*: any*/)
  ]
},
v31 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v32 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v33 = [
  (v7/*: any*/)
],
v34 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v7/*: any*/),
          (v12/*: any*/),
          (v23/*: any*/),
          (v22/*: any*/)
        ],
        "type": "AtlassianAccountUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v33/*: any*/),
        "type": "AppUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v33/*: any*/),
        "type": "CustomerUser"
      }
    ]
  },
  (v7/*: any*/)
],
v35 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v27/*: any*/)
},
v36 = {
  "kind": "ScalarField",
  "name": "newTargetDate"
},
v37 = {
  "kind": "ScalarField",
  "name": "newTargetDateConfidence"
},
v38 = {
  "kind": "ScalarField",
  "name": "archived"
},
v39 = {
  "concreteType": "TownsquareUpdateNoteConnection",
  "kind": "LinkedField",
  "name": "updateNotes",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareUpdateNoteEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareUpdateNote",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            (v38/*: any*/)
          ]
        }
      ]
    }
  ]
},
v40 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v41 = [
  (v6/*: any*/),
  (v22/*: any*/),
  (v12/*: any*/),
  (v23/*: any*/),
  (v7/*: any*/)
],
v42 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v41/*: any*/)
},
v43 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v41/*: any*/)
},
v44 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v45 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v46 = {
  "concreteType": "TownsquareHighlightConnection",
  "kind": "LinkedField",
  "name": "highlights",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareHighlightEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            (v15/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v40/*: any*/),
            (v42/*: any*/),
            (v43/*: any*/),
            (v31/*: any*/),
            (v44/*: any*/)
          ]
        }
      ]
    },
    (v45/*: any*/)
  ]
},
v47 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v6/*: any*/),
                (v12/*: any*/),
                (v7/*: any*/),
                (v23/*: any*/),
                (v22/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v32/*: any*/),
            (v31/*: any*/)
          ]
        }
      ]
    },
    (v45/*: any*/)
  ]
},
v48 = {
  "kind": "ScalarField",
  "name": "value"
},
v49 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v50 = [
  (v48/*: any*/)
],
v51 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v52 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v50/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v51/*: any*/)
  ]
},
v53 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v50/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v51/*: any*/)
  ]
},
v54 = {
  "kind": "ScalarField",
  "name": "type"
},
v55 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v56 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v57 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v56/*: any*/),
    (v54/*: any*/)
  ]
},
v58 = {
  "kind": "ScalarField",
  "name": "subType"
},
v59 = {
  "kind": "ScalarField",
  "name": "source"
},
v60 = {
  "kind": "ScalarField",
  "name": "time"
},
v61 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    (v60/*: any*/),
    (v7/*: any*/)
  ]
},
v62 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v12/*: any*/),
                (v54/*: any*/),
                (v58/*: any*/),
                (v38/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "externalEntityId"
                },
                (v59/*: any*/),
                (v61/*: any*/)
              ]
            },
            {
              "concreteType": "TownsquareMetricValue",
              "kind": "LinkedField",
              "name": "snapshotValue",
              "plural": false,
              "selections": [
                (v48/*: any*/),
                (v7/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "startValue"
            },
            {
              "kind": "ScalarField",
              "name": "targetValue"
            }
          ]
        }
      ]
    }
  ]
},
v63 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": [
    (v26/*: any*/)
  ]
},
v64 = [
  (v6/*: any*/),
  (v23/*: any*/),
  (v12/*: any*/),
  (v22/*: any*/),
  (v7/*: any*/)
],
v65 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v64/*: any*/)
},
v66 = {
  "kind": "ScalarField",
  "name": "score"
},
v67 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v64/*: any*/)
},
v68 = [
  (v31/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v48/*: any*/),
      (v66/*: any*/),
      (v24/*: any*/)
    ]
  },
  (v14/*: any*/),
  (v67/*: any*/),
  (v39/*: any*/),
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v40/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v31/*: any*/),
              (v44/*: any*/)
            ]
          }
        ]
      },
      (v45/*: any*/)
    ]
  },
  (v7/*: any*/)
],
v69 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v68/*: any*/)
},
v70 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ]
},
v71 = [
  (v48/*: any*/),
  (v66/*: any*/)
],
v72 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v71/*: any*/)
},
v73 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v74 = [
  {
    "concreteType": "TownsquareGoalUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareGoalUpdate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          (v21/*: any*/),
          (v14/*: any*/),
          (v32/*: any*/),
          (v31/*: any*/),
          (v7/*: any*/)
        ]
      }
    ]
  }
],
v75 = [
  (v48/*: any*/),
  (v60/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "UpdatesTabAggQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/),
          {
            "kind": "Variable",
            "name": "shouldFetchUpdatesTabData",
            "variableName": "shouldFetchUpdatesTabData"
          },
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "UpdatesTabAgg_data"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdatesTabAggQuery",
    "selections": [
      {
        "condition": "shouldFetchUpdatesTabData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "TownsquareUpdateConnection",
            "kind": "LinkedField",
            "name": "statusUpdates_byTag",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          {
                            "concreteType": "TownsquareProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "watching"
                              },
                              (v8/*: any*/),
                              {
                                "concreteType": "TownsquareProjectCapabilities",
                                "kind": "LinkedField",
                                "name": "capabilities",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canWatchProject"
                                  },
                                  (v9/*: any*/),
                                  (v10/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isPrivate"
                              },
                              {
                                "concreteType": "TownsquareIconURIs",
                                "kind": "LinkedField",
                                "name": "iconUrl",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareThemeURIs",
                                    "kind": "LinkedField",
                                    "name": "square",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "light"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "dark"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "transparent"
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "startDate"
                              },
                              {
                                "concreteType": "TownsquareProjectUpdate",
                                "kind": "LinkedField",
                                "name": "latestUserUpdate",
                                "plural": false,
                                "selections": (v16/*: any*/)
                              },
                              (v17/*: any*/),
                              {
                                "concreteType": "TownsquareProjectCapabilities",
                                "kind": "LinkedField",
                                "name": "capabilities",
                                "plural": false,
                                "selections": [
                                  (v18/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v12/*: any*/),
                              (v22/*: any*/),
                              (v7/*: any*/),
                              (v23/*: any*/)
                            ]
                          },
                          (v28/*: any*/),
                          {
                            "concreteType": "TownsquareProjectState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": (v29/*: any*/)
                          },
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v17/*: any*/),
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection",
                            "kind": "LinkedField",
                            "name": "viewers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v34/*: any*/)
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareProjectState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": (v29/*: any*/)
                          },
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v39/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/)
                        ],
                        "type": "TownsquareProjectUpdate"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "isWatching"
                              },
                              (v8/*: any*/),
                              {
                                "concreteType": "TownsquareGoalCapabilities",
                                "kind": "LinkedField",
                                "name": "capabilities",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canWatchGoal"
                                  },
                                  (v18/*: any*/),
                                  (v10/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "canDeleteUpdates"
                                  },
                                  (v9/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "parentGoal",
                                "plural": false,
                                "selections": (v33/*: any*/)
                              },
                              (v11/*: any*/),
                              (v12/*: any*/),
                              {
                                "concreteType": "TownsquareGoalIcon",
                                "kind": "LinkedField",
                                "name": "icon",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "appearance"
                                  }
                                ]
                              },
                              {
                                "concreteType": "TownsquareMetricTargetConnection",
                                "kind": "LinkedField",
                                "name": "metricTargets",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTargetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTarget",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetric",
                                            "kind": "LinkedField",
                                            "name": "metric",
                                            "plural": false,
                                            "selections": [
                                              (v7/*: any*/),
                                              (v38/*: any*/)
                                            ]
                                          },
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodConnection",
                                            "kind": "LinkedField",
                                            "name": "metricTargetPeriods",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriodEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareMetricTargetPeriod",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDate",
                                                        "kind": "LinkedField",
                                                        "name": "date",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "TownsquareTargetDateRange",
                                                            "kind": "LinkedField",
                                                            "name": "dateRange",
                                                            "plural": false,
                                                            "selections": [
                                                              (v25/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      (v48/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v7/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v49/*: any*/),
                              (v38/*: any*/),
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "goalType",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                      (v52/*: any*/),
                                      (v53/*: any*/),
                                      (v7/*: any*/)
                                    ]
                                  },
                                  (v7/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TownsquareGoalProgress",
                                "kind": "LinkedField",
                                "name": "progress",
                                "plural": false,
                                "selections": [
                                  (v54/*: any*/)
                                ]
                              },
                              {
                                "args": (v55/*: any*/),
                                "concreteType": "TownsquareGoalConnection",
                                "kind": "LinkedField",
                                "name": "successMeasures",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v12/*: any*/),
                                          (v38/*: any*/),
                                          (v57/*: any*/),
                                          (v62/*: any*/),
                                          (v17/*: any*/),
                                          (v49/*: any*/),
                                          (v63/*: any*/),
                                          (v65/*: any*/),
                                          (v69/*: any*/),
                                          (v8/*: any*/),
                                          (v13/*: any*/),
                                          {
                                            "concreteType": "TownsquareGoalType",
                                            "kind": "LinkedField",
                                            "name": "goalType",
                                            "plural": false,
                                            "selections": [
                                              (v52/*: any*/),
                                              (v53/*: any*/),
                                              (v70/*: any*/),
                                              (v7/*: any*/)
                                            ]
                                          },
                                          (v72/*: any*/),
                                          {
                                            "args": (v73/*: any*/),
                                            "concreteType": "TownsquareGoalUpdateConnection",
                                            "kind": "LinkedField",
                                            "name": "updates",
                                            "plural": false,
                                            "selections": (v74/*: any*/),
                                            "storageKey": "updates(first:10)"
                                          }
                                        ]
                                      },
                                      (v6/*: any*/)
                                    ]
                                  }
                                ],
                                "storageKey": "successMeasures(first:50)"
                              },
                              {
                                "concreteType": "TownsquareGoalConnection",
                                "kind": "LinkedField",
                                "name": "subGoals",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v12/*: any*/),
                                          (v38/*: any*/),
                                          (v57/*: any*/),
                                          {
                                            "concreteType": "TownsquareGoalType",
                                            "kind": "LinkedField",
                                            "name": "goalType",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "kind"
                                              },
                                              (v7/*: any*/),
                                              (v70/*: any*/)
                                            ]
                                          },
                                          (v62/*: any*/),
                                          (v17/*: any*/),
                                          (v49/*: any*/),
                                          (v63/*: any*/),
                                          (v65/*: any*/),
                                          (v69/*: any*/),
                                          (v13/*: any*/),
                                          (v72/*: any*/),
                                          {
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 30
                                              }
                                            ],
                                            "concreteType": "TownsquareGoalUpdateConnection",
                                            "kind": "LinkedField",
                                            "name": "updates",
                                            "plural": false,
                                            "selections": (v74/*: any*/),
                                            "storageKey": "updates(first:30)"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "args": (v73/*: any*/),
                                "concreteType": "TownsquareGoalUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v16/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:10)"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canPostUpdate"
                              },
                              (v13/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "canEditUpdate"
                              }
                            ]
                          },
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v14/*: any*/),
                          {
                            "concreteType": "TownsquareGoalState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": (v71/*: any*/)
                          },
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v39/*: any*/),
                          (v46/*: any*/),
                          (v31/*: any*/),
                          {
                            "concreteType": "TownsquareGoalMetricUpdateConnection",
                            "kind": "LinkedField",
                            "name": "metricUpdate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalMetricUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v12/*: any*/),
                                          (v54/*: any*/),
                                          (v58/*: any*/),
                                          (v38/*: any*/),
                                          (v59/*: any*/),
                                          (v61/*: any*/),
                                          {
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 100
                                              },
                                              {
                                                "kind": "Literal",
                                                "name": "sort",
                                                "value": [
                                                  "TIME_DESC"
                                                ]
                                              }
                                            ],
                                            "concreteType": "TownsquareMetricValueConnection",
                                            "kind": "LinkedField",
                                            "name": "values",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareMetricValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v75/*: any*/)
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "newValue",
                                        "plural": false,
                                        "selections": (v75/*: any*/)
                                      },
                                      {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "oldValue",
                                        "plural": false,
                                        "selections": [
                                          (v60/*: any*/),
                                          (v7/*: any*/),
                                          (v48/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newStartValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newTargetValue"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v67/*: any*/),
                          (v28/*: any*/),
                          {
                            "args": (v55/*: any*/),
                            "concreteType": "TownsquareGoalBundledUpdateConnection",
                            "kind": "LinkedField",
                            "name": "bundledUpdates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalBundledUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalProgress",
                                        "kind": "LinkedField",
                                        "name": "progress",
                                        "plural": false,
                                        "selections": [
                                          (v56/*: any*/)
                                        ]
                                      },
                                      (v7/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v68/*: any*/)
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "nodeMissingReason"
                                  },
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "goal",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v12/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalProgress",
                                        "kind": "LinkedField",
                                        "name": "progress",
                                        "plural": false,
                                        "selections": [
                                          (v54/*: any*/),
                                          (v56/*: any*/)
                                        ]
                                      },
                                      (v62/*: any*/),
                                      (v17/*: any*/),
                                      (v49/*: any*/),
                                      (v63/*: any*/),
                                      (v65/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "bundledUpdates(first:50)"
                          },
                          (v30/*: any*/),
                          (v32/*: any*/),
                          (v17/*: any*/),
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                            "kind": "LinkedField",
                            "name": "viewers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v34/*: any*/)
                              }
                            ]
                          },
                          (v19/*: any*/),
                          (v47/*: any*/),
                          {
                            "concreteType": "TownsquareGoalState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": (v71/*: any*/)
                          },
                          (v35/*: any*/)
                        ],
                        "type": "TownsquareGoalUpdate"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v33/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              }
            ]
          },
          {
            "args": (v5/*: any*/),
            "filters": [
              "tagId",
              "containerId"
            ],
            "handle": "connection",
            "key": "UpdatesTabAgg_statusUpdates_byTag",
            "kind": "LinkedHandle",
            "name": "statusUpdates_byTag"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a45bbfcccd8477665b704a072b03919caa8e4f98f1dad76a073ad87cd50ad9a0",
    "metadata": {},
    "name": "UpdatesTabAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "94f8363bcded19828c14905596f858fd";

export default node;
